import { canRead, canWrite } from '../access/rbacAccess'

export const QUOTES = {
  LIST: 'ejecuta.quotes'
}

export const canViewQuotes = () => canRead(QUOTES.LIST)

export const canManageQuotes = () => canWrite(QUOTES.LIST)
